import { MouseEvent, useState } from "react";
import { DateRange, SelectRangeEventHandler } from "react-day-picker";

const useSelectDate = () => {
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);
  const [date, setDate] = useState<DateRange | undefined>();

  const handleOpenUserMenu = (event: MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
    setDate(undefined);
  };

  const handleConform = () => {
    setAnchorElUser(null);
  };

  const handleSelect: SelectRangeEventHandler = (nextRange, selectedDay) => {
    setDate((range) => {
      if (range?.from && range?.to) return { from: selectedDay };
      return nextRange as DateRange;
    });
  };

  return {
    date,
    anchorElUser,
    handleOpenUserMenu,
    handleCloseUserMenu,
    handleSelect,
    setDate,
    handleConform,
  };
};

export default useSelectDate;
